import React, {Component} from "react";
import {connect} from "react-redux";
import {ReactSVG} from "react-svg";

import * as actions from "../../actions/virtualKeyboardActions";
import * as characters from "../../constants/keyboardLayouts";
import * as languages from "../../constants/languages";

import imgClose from "../../resources/img/svgicons/keyboard.svg";

class UniversalKeyboard extends Component {
    universalKeyboard = null;

    constructor(props) {
        super(props);

        this.state = {
            initialized: false
        };
    }

    componentDidMount = () => {
        let self = this;

        if (window.jQuery.keyboard !== undefined) {
            this.setState({initialized: true});
            window.jQuery.extend(window.jQuery.keyboard.keyaction, {
                cancel: function () {
                    if (window.jQuery("#" + self.props.selector).length) {
                        window.jQuery("#" + self.props.selector).val("");
                    }

                    return true;
                }
            });

            if (characters[this.props.layout] === undefined) {
                window.jQuery.keyboard.layouts[languages.ENGLISH] = characters[languages.ENGLISH];
            } else {
                window.jQuery.keyboard.layouts[this.props.layout] = characters[this.props.layout];
            }

            if (this.props.keyboard) {
                this.createKeyboard("#" + this.props.selector);
            }
        }
    };

    componentWillUnmount = () => {
        this.destroyKeyboard(
            function () {
                this.universalKeyboard = null;
            }.bind(this)
        );
    };

    componentDidUpdate = (prevProps) => {
        let created = false;
        if (this.props.keyboard !== prevProps.keyboard) {
            if (this.universalKeyboard === null && this.props.keyboard) {
                this.createKeyboard("#" + this.props.selector);
                created = true;
            }
            if (this.universalKeyboard !== null && !this.props.keyboard) {
                this.destroyKeyboard(
                    function () {
                        this.universalKeyboard = null;
                    }.bind(this)
                );
            }
        }

        if (this.props.selector !== prevProps.element) {
            if (this.props.keyboard && !created) {
                this.createKeyboard("#" + this.props.selector);
            }
        }
        this.setKeyboardStyle();
    };

    destroyKeyboard = (callback) => {
        if (this.universalKeyboard !== null) {
            this.universalKeyboard.keyboard().getkeyboard().destroy(callback);
        }
    };

    configurateKeyboard = (element) => {
        if (!this.state.initialized) {
            return false;
        }

        let self = this;
        let keyboardInput = window.jQuery(element);

        if (keyboardInput.length === 0) {
            keyboardInput = window.jQuery("#barcode-scanner-input");
        }

        this.universalKeyboard = keyboardInput.keyboard({
            layout: characters[this.props.layout] === undefined ? languages.ENGLISH : this.props.layout,
            position: {
                of: window.jQuery("#universal-keyboard-anchor"),
                my: "center top",
                at: "center top",
                at2: "center top"
            },
            reposition: true,
            alwaysOpen: true,
            stayOpen: true,
            usePreview: false,
            appendTo: "#universal-keyboard-anchor",
            change: function (e, keyboard, el) {
                if (e.originalEvent === undefined) {
                    window.jQuery(el).trigger("change");

                    return false;
                }

                if (e.action !== "cancel") {
                    self.props.dispatchSetKeyboardTextAction(window.jQuery(el).val());
                    window.jQuery(el).trigger("change");

                    return true;
                }

                self.props.dispatchSetKeyboardTextAction("");
                window.jQuery(el).val("");
                window.jQuery(el).trigger("change");

                return false;
            }
        });

        return true;
    };

    createKeyboard = (element) => {
        if (this.universalKeyboard !== null) {
            this.universalKeyboard
                .keyboard()
                .getkeyboard()
                .destroy(
                    function () {
                        this.configurateKeyboard(element);
                    }.bind(this)
                );
        } else {
            this.configurateKeyboard(element);
        }
    };

    handleOpenKeyboardButtonClick = () => {
        this.props.dispatchSetUniversalKeyboardStateAction(true, "test");
    };

    handleCloseKeyboardButtonClick = () => {
        this.destroyKeyboard(
            function () {
                this.props.dispatchSetKeyboardStateAction(false);
            }.bind(this)
        );
    };

    setKeyboardStyle = () => {
        window.jQuery(".ui-keyboard").css("WebkitAppRegion", "no-drag");
    };

    render() {
        if (!this.state.initialized || !this.props.virtualKeyboardEnabled) {
            return "";
        }

        if (!this.props.keyboard) {
            return (
                <div className="keyboard-show-btn-box" onClick={this.handleOpenKeyboardButtonClick}>
                    <ReactSVG src={imgClose} className="keyboard-icon" alt="open" />
                </div>
            );
        }

        return (
            <React.Fragment>
                <div id="universal-keyboard-anchor" className="col-xs-12" style={{WebkitAppRegion: "no-drag"}} />
                <button
                    style={{WebkitAppRegion: "no-drag"}}
                    className="keyboard-close-btn"
                    onClick={this.handleCloseKeyboardButtonClick}
                >
                    <span className="glyphicon glyphicon-menu-down" />
                </button>
            </React.Fragment>
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        layout: store.settings.keyboard,
        keyboard: store.virtualKeyboard.keyboardState,
        selector: store.virtualKeyboard.selector,
        virtualKeyboardEnabled: store.settings.virtualKeyboardEnabled
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchSetKeyboardStateAction: (state) => {
            dispatch(actions.setKeyBoardState(state));
        },
        dispatchSetUniversalKeyboardStateAction: (state, selector) => {
            dispatch(actions.setUniversalKeyboardState(state, selector));
        },
        dispatchSetKeyboardTextAction: (text) => {
            dispatch(actions.setKeyboardText(text));
        }
    };
};

export default UniversalKeyboard = connect(mapStoreToProps, mapDispatchToProps)(UniversalKeyboard);
